const zh = {
    title: '你喜愛的DApp和DeFi',
    subtitle: '通過這些連接區塊鏈世界',
    download: '下載錢包',
    thanks: '感謝社區鼓勵與贊助',
    add: '收藏到TockenPocket',
    scanSave: '使用TokenPocket扫描后收藏',
    submitDApps: '提交 DApps'
};

export default zh;
